(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  function ready() {
    const launch = document.querySelector('[data-enter-shop]');
    launch?.addEventListener('click', event => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0 || reduced.matches) return;
      event.preventDefault();
      if (document.body.classList.contains('launching')) return;
      try{sessionStorage.setItem('koll-landing-entry','1');}catch{}
      document.body.classList.add('launching');
      document.querySelector('#entry-status').textContent = 'Dein Online-Shop öffnet sich.';
      // The same curtain is picked up on the next page; normal links remain
      // usable without JavaScript or when opening a separate browser tab.
      setTimeout(() => location.assign(launch.href), 620);
    });
    addEventListener('pageshow', () => document.body.classList.remove('launching'));
    if (document.body.hasAttribute('data-storefront')) {
      document.title = 'Dein Draußen — KOLL Living Online-Shop';
      if(document.querySelector('footer>p')) document.querySelector('footer>p').textContent = 'Dein Draußen. Direkt von KOLL Living.';
      const cleanUrl = new URL(location.href);
      cleanUrl.searchParams.delete('richtung');
      history.replaceState(null, '', cleanUrl.pathname + cleanUrl.search + cleanUrl.hash);
      document.addEventListener('click', event => {
        if (event.target.closest('[data-product-choice],.stage-navigation button')) document.documentElement.classList.remove('shop-entering');
      }, {capture:true});
      // First navigation gets the complete choreography; restoring a page
      // from browser history never hides the customer's current position.
      addEventListener('pageshow', event => {
        if (event.persisted) document.documentElement.classList.remove('shop-entering');
      });
      setTimeout(() => document.documentElement.classList.remove('shop-entering'), reduced.matches ? 0 : 2400);
    }
  }
  if (document.readyState === 'complete') ready(); else document.addEventListener('DOMContentLoaded', ready, {once:true});
})();
